import React from 'react';
import {
  SystemModal,
  Box,
  Button,
  Body,
  Heading,
  SystemModalHeader,
  SystemModalIcon,
  Glyph,
  Flex,
  SystemModalContent,
} from '@edreamsodigeo/prisma-design-system';
import {
  useTranslation,
  withTrackComponentDisplayed,
  RouterLink,
} from '@edreamsodigeo/frontend-core';

export const HTML_EVENT_DISPLAY_ID = 'flights-broken-flow-modal';
const SystemModalWithId = (props) => (
  <SystemModal {...props} html-event-id={HTML_EVENT_DISPLAY_ID} />
);
const ModalWithTracking = withTrackComponentDisplayed(
  SystemModalWithId,
  HTML_EVENT_DISPLAY_ID
);

const HOME_LINK = '/';
const RESULT_LINK = 'results';

const ResultsButton = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <Button onClick={onClick} fullWidth size="large" type="primary">
      {t('brokenFlow.link.results')}
    </Button>
  );
};

const ResultsLink = ({ onClick }) => {
  const isHomePage = window?.location.pathname === '/';

  if (isHomePage) return null;

  return (
    <RouterLink href={RESULT_LINK}>
      <ResultsButton onClick={onClick} />
    </RouterLink>
  );
};

const HomeLink = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <RouterLink href={HOME_LINK}>
      <Button onClick={onClick} fullWidth size="large" type="secondary">
        {t('brokenFlow.link.home')}
      </Button>
    </RouterLink>
  );
};

export const BrokenFlowModal = ({ isOpen, close }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <ModalWithTracking
      size={{ md: 'large', _: 'full' }}
      p="small"
      open={isOpen}
      id={HTML_EVENT_DISPLAY_ID}
      onClose={() => {}}
      sx={{ maxWidth: { _: null, md: '392px' } }}
    >
      <SystemModalHeader type="warning">
        <SystemModalIcon>
          <Glyph
            category="Alerts"
            name="Warning"
            size="medium"
            color="orange.50"
          />
        </SystemModalIcon>
      </SystemModalHeader>
      <SystemModalContent>
        <Flex flexDirection="column" justifyContent="center">
          <Heading
            type="2"
            textAlign="center"
            color="neutral.90"
            weight="medium"
          >
            {t('brokenFlow.heading.text')}
          </Heading>
          <Body
            textAlign="center"
            type="base"
            color="neutral.80"
            weight="normal"
          >
            {t('brokenFlow.description.text')}
          </Body>
          <Box mt="1x_big" mb="base">
            <ResultsLink onClick={close} />
          </Box>
          <Box>
            <HomeLink onClick={close} />
          </Box>
        </Flex>
      </SystemModalContent>
    </ModalWithTracking>
  );
};
